import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Link, Route, Routes, useLocation } from "react-router-dom";
import "./navbarheader.css";
import Header1 from "../../components/cmpNavbarHeader/Header1";
import Header2 from "../../components/cmpNavbarHeader/Header2";
import Header3 from "../../components/cmpNavbarHeader/Header3";
import Header4 from "../../components/cmpNavbarHeader/Header4";
import Banner from "../../components/cmpNavbarHeader/Banner";
import Jumbotron from "../../components/cmpNavbarHeader/Jumbotron";
import { useTranslation, withTranslation } from "react-i18next";


const NavbarHeader: React.FC = () => {
    const location = useLocation();
    const [haveButton, setHaveButton] = useState<boolean>(false);
    const [showBanner, setShowBanner] = useState<boolean>(false);

    useEffect(() => {
        setShowBanner(window.localStorage.getItem("hasPromocode")?.toLowerCase() !== "false")
    }, [])

    useEffect(() => {
        if(location.pathname === "/Home" || location.pathname === "/"){
            setHaveButton(true)
            return;
        };
        setHaveButton(false);
        return;
    }, [location.pathname]);
    return (
        <div className="header-parent">
            <div className="header">
                <Header1 />
                <Header2 />
                <div className="header3_container">
                    <Header3 />
                </div>
            </div>

            <div className="banner-jumbotron">
                {showBanner && (
                    <Banner />
                )}
                <Jumbotron haveButton={haveButton} />
            </div>
        </div>
    );
  };
  export default withTranslation('translation', { withRef: true }) (NavbarHeader);



